import { render } from "./FAQQuestionBlock.vue?vue&type=template&id=fc484ed6"
import script from "./FAQQuestionBlock.vue?vue&type=script&lang=js"
export * from "./FAQQuestionBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__